import React from "react";
import { IconButton } from "@material-ui/core";
import CachedIcon from "@material-ui/icons/Cached";
import { i18n } from "../../translate/i18n";

/** Botão de recarregar a página (navbar). */
const RefreshButton = () => (
  <IconButton
    onClick={() => window.location.reload(false)}
    aria-label={i18n.t("mainDrawer.appBar.refresh")}
    color="inherit"
  >
    <CachedIcon style={{ color: "white" }} />
  </IconButton>
);


export default RefreshButton;
